export const pillars = [
  'Neurobiología',
  'Umbral del Dolor',
  'Flow Mental',
  'Ansiedad',
  'Visualización',
  'Identidad Atlética',
];

export const tomos = [
  {
    n: 1,
    emoji: '🧠',
    title: 'Neurobiología del Esfuerzo',
    desc: 'Cómo tu cerebro decide cuándo cansarte y por qué la fatiga es una decisión mental antes que física. El primer mito que destruirás.',
  },
  {
    n: 2,
    emoji: '🔥',
    title: 'El Umbral del Dolor',
    desc: 'Técnicas para hackear la fatiga central y reprogramar el punto exacto donde tu cerebro activa el botón de emergencia.',
  },
  {
    n: 3,
    emoji: '🚫',
    title: 'Adiós al Autosabotaje',
    desc: 'Identificá y silenciá la voz interna que te pide parar. Sistema de neutralización de pensamientos saboteadores en tiempo real.',
  },
  {
    n: 4,
    emoji: '🎯',
    title: 'Foco de Élite',
    desc: 'Técnicas de concentración profunda para carreras largas. Cómo mantener la atención cuando el cuerpo pide que la mente se distraiga.',
  },
  {
    n: 5,
    emoji: '⚡',
    title: 'Anclajes de Poder',
    desc: 'Disparadores mentales programados para activar tu máximo rendimiento en los momentos más críticos de cualquier carrera.',
  },
  {
    n: 6,
    emoji: '🛡️',
    title: 'Resiliencia en el Asfalto',
    desc: 'Gestión emocional ante el fracaso, la lesión y el mal día. Cómo caer sin romperte y levantarte más fuerte que antes.',
  },
  {
    n: 7,
    emoji: '🎬',
    title: 'Visualización Kinestésica',
    desc: 'Ensayá tu victoria antes de correr. El protocolo de visualización que usan los atletas olímpicos para ganar antes del disparo.',
  },
  {
    n: 8,
    emoji: '🫁',
    title: 'Ansiedad Bajo Control',
    desc: 'Dominá los nervios pre-competencia. Técnicas de regulación del sistema nervioso para llegar al inicio tranquilo y letal.',
  },
  {
    n: 9,
    emoji: '🌊',
    title: 'El Estado de Flow',
    desc: 'Cómo entrar en la zona de máximo rendimiento donde correr deja de ser esfuerzo y se convierte en algo cercano al éxtasis.',
  },
  {
    n: 10,
    emoji: '📍',
    title: 'Micro-Metas',
    desc: 'El arte de engañar al cansancio dividiéndolo en tramos. El sistema que usan los ultramaratonistas para correr 100 km sin ver la distancia total.',
  },
  {
    n: 11,
    emoji: '😴',
    title: 'Recuperación Cognitiva',
    desc: 'Por qué el cerebro necesita recuperarse igual que el músculo y cómo hacerlo en la mitad del tiempo.',
  },
  {
    n: 12,
    emoji: '🏅',
    title: 'Identidad Imparable',
    desc: 'De alguien que corre a ser un Atleta Mental. Construí la identidad que hace que el esfuerzo sea una consecuencia natural.',
  },
];

export const tomoIncludes = [
  'Técnicas listas para aplicar',
  'Protocolos paso a paso',
  'Ejercicios de regulación mental',
  'Checklists de implementación',
  'Listo para aplicar desde hoy',
];

export const bonuses = [
  {
    n: '01',
    title: 'CALCULADORA DE RITMOS-EFICIENTES',
    desc: 'La herramienta definitiva para dejar de correr a ciegas. Calculá tus zonas de entrenamiento exactas para maximizar el rendimiento sin agotar tu sistema nervioso. Incluye guía de interpretación de datos.',
    price: '$15',
  },
  {
    n: '02',
    title: 'PROTOCOLO DE CALENTAMIENTO MENTAL',
    desc: 'No solo calientes los músculos. Este manual te enseña a "encender" tus neurotransmisores 15 minutos antes de salir, eliminando la pereza inicial y el bloqueo de arranque.',
    price: '$14',
  },
  {
    n: '03',
    title: 'PLAN DE RECUPERACIÓN COGNITIVA',
    desc: 'El cansancio no es solo físico. Técnicas de neuro-descanso para que tu cerebro se recupere del esfuerzo tan rápido como tus piernas, evitando el burnout del corredor crónico.',
    price: '$12',
  },
  {
    n: '04',
    title: 'PLAN DE ALIMENTACIÓN NEURO-ENERGÉTICA',
    desc: 'Qué comer y cuándo para mantener la glucosa cerebral estable y evitar los "apagones mentales" en kilómetros críticos. Nutrición específica para el cerebro del corredor.',
    price: '$10',
  },
  {
    n: '05',
    title: 'CHECKLIST PRE-CARRERA SIN ESTRÉS',
    desc: 'El sistema "anti-olvidos" definitivo. La lista detallada de todo lo que debés preparar la noche anterior para que tu mente duerma tranquila y tu única preocupación sea correr y ganar.',
    price: '$10',
  },
];
